import axios from 'axios'
import {ResponseObject, ResponseObjectPaginated} from '../model'
import {
  AttendClaimUserDocument,
  AttendClaimUserModel,
  ClaimUserDocument,
  ClaimUserModel,
  ClaimUserModelDocument,
  GetClaimUserFilter,
  GetClaimUserModel,
} from '../model/claimUser.model'
import {ID} from '../../../../../_metronic/helpers'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

export function getClaims(dto: GetClaimUserFilter, page: number) {
  return axios.post<ResponseObjectPaginated<ClaimUserModelDocument[]>>(
    `${BASEURL}/request/getAll/${page}`,
    dto,
  )
}

export async function createClaim(dto: ClaimUserModel) {
  return await axios.post<ResponseObject<ClaimUserModel>>(
    `${BASEURL}/request/createRequestUser`,
    dto,
  )
}

export async function getClaimById(id: string | undefined | number) {
  return await axios.get<ResponseObject<GetClaimUserModel>>(`${BASEURL}/request/getRequestById`, {
    params: {
      Id: id,
    },
  })
}

export async function updateClaim(dto: ClaimUserModel) {
  return await axios.put<ResponseObject<ClaimUserModel>>(`${BASEURL}/request/updateRequest`, dto)
}

export async function getAttentionList(requerimientoId: string, page: number) {
  return await axios.post<ResponseObjectPaginated<AttendClaimUserDocument>>(
    `${BASEURL}/request/getListAttention/${page}?RequerimientoId=${requerimientoId}`,
  )
}

export async function deleteClaim(requerimientoId: string | undefined) {
  return await axios.delete<ResponseObject<ClaimUserModel>>(
    `${BASEURL}/request/deleteRequest?requerimientoId=${requerimientoId}`,
  )
}

// DOCUMENTS

export function getClaimDocumentsService(requerimientoId: ID, page: number) {
  return axios.post<ResponseObjectPaginated<ClaimUserDocument[]>>(
    `${BASEURL}/request/getListDocument/${page}?RequerimientoId=${requerimientoId}`,
    {},
  )
}

export async function createClaimDocumentsService(test: any, requerimientoId: ID) {
  return await axios.post<ResponseObject<ClaimUserDocument>>(
    `${BASEURL}/request/createRequestDocument?RequerimientoId=${requerimientoId}`,
    test,
  )
}

export async function createClaimAttentionService(dto: AttendClaimUserModel) {
  return await axios.post<ResponseObject<AttendClaimUserModel>>(
    `${BASEURL}/request/createRequestAttention`,
    dto,
  )
}

export async function updateClaimAttentionService(dto: AttendClaimUserModel) {
  return await axios.put<ResponseObject<AttendClaimUserModel>>(
    `${BASEURL}/request/updateRequestAttention`,
    dto,
  )
}

export function downloadClaimDocumentsAttentionService(requerimientoId: any) {
  return axios.get<any>(
    `${BASEURL}/request/downloadRequestAttentionDocument?RequerimientoId=${requerimientoId}`,
  )
}

export async function finalizeClaim(requerimientoId: ID) {
  return axios.put<ResponseObject<ClaimUserModel>>(
    `${BASEURL}/request/finalizeRequest?requerimientoId=${requerimientoId}`,
  )
}

export function downloadClaimDocumentsService(requerimientoId: any) {
  return axios.get<any>(
    `${BASEURL}/request/downloadRequestDocument?RequerimientoId=${requerimientoId}`,
  )
}
